import { Route, Routes } from 'react-router-dom'
import Auth from '../../middleware/Auth'
import HasAnyIdentity from '../../middleware/HasAnyIdentity'
import DashboardLayout from '../../layouts/dashboard/DashboardLayout'
import ProtectedRoute from '../../middleware/ProtectedRoute'
import MembersDB from '../../pages/dashboard/MembersDB'
import MemberLecturesDB from '../../pages/dashboard/MemberLecturesDB'
import MemberLectureDetailsDB from '../../pages/dashboard/MemberLectureDetails'
import CoursesDB from '../../pages/dashboard/CoursesDB'
import LecturesDB from '../../pages/dashboard/LecturesDB'
import LectureDB from '../../pages/dashboard/LectureDB'
import QuizesDB from '../../pages/dashboard/QuizesDB'
import QuizOptionsDB from '../../pages/dashboard/QuizOptionsDB'
import QuestionsAndAnswersDB from '../../pages/dashboard/QuestionsAndAnswersDB'
import LectureVouchersDB from '../../pages/dashboard/LectureVouchersDB'
import OffersDB from '../../pages/dashboard/OffersDB'
import CreateOffersDB from '../../pages/dashboard/CreateOffersDB'
import UpdateOffersDB from '../../pages/dashboard/UpdateOffersDB'
import OfferVouchersDB from '../../pages/dashboard/OfferVouchersDB'
import AssociateUsersPermissionsDB from '../../pages/dashboard/AssociateUsersPermissionsDB'
import RolesDB from '../../pages/dashboard/RolesDB'
import CreateRolesDB from '../../pages/dashboard/CreateRolesDB'
import UpdateRolesDB from '../../pages/dashboard/UpdateRolesDB'
import ErrorPage from '../../components/errorPage/ErrorPage'
import Dashboard from '../../pages/dashboard/Dashboard'
import Vouchers from '../../pages/dashboard/CreateVouchersDB'
import LectureStudents from '../../pages/dashboard/LectureStudents'

const DashBoardRoutes = () => {
    return (
        <Routes>
            {/* Dashboard Routes and layout  */}
            <Route
                element={
                    <Auth>
                        <HasAnyIdentity hasIdentities={["admin"]}>
                            <DashboardLayout />
                        </HasAnyIdentity>
                    </Auth>
                }
            >
                <Route path="/dashboard" element={
                    <ProtectedRoute permissions={["read:users", "read:offers", "read:course:lectures", "read:courses"]}>
                        <Dashboard />
                    </ProtectedRoute>
                } />

                {/* Vouchers */}
                <Route path="/vouchers" element={
                    <ProtectedRoute permissions={["create:grade:voucher:codes"]}>
                        <Vouchers />
                    </ProtectedRoute>
                } />

                {/* Members */}
                <Route path="/members" element={
                    <ProtectedRoute permissions={["read:users"]}>
                        <MembersDB />
                    </ProtectedRoute>
                } />

                <Route
                    path="/members/:userId/lectures" element={
                        <ProtectedRoute permissions={["read:course:lectures"]}>
                            <MemberLecturesDB />
                        </ProtectedRoute>
                    } />

                <Route
                    path="/members/:userId/courses/:courseId/lectures/:lectureId" element={
                        <ProtectedRoute permissions={["read:course:lectures", "read:course:lecture:items"]} allRequired={true}>
                            <MemberLectureDetailsDB />
                        </ProtectedRoute>
                    } />

                {/* Courses */}
                <Route
                    path="/courses" element={
                        <ProtectedRoute permissions={["read:courses"]}>
                            <CoursesDB />
                        </ProtectedRoute>
                    } />

                <Route
                    path="/courses/:courseId/lectures" element={
                        <ProtectedRoute permissions={["read:course:lectures"]}>
                            <LecturesDB />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/courses/:courseId/lectures/:lectureId" element={
                        <ProtectedRoute permissions={["read:course:lecture:items"]}>
                            <LectureDB />
                        </ProtectedRoute>
                    } />
                <Route
                    path="/courses/:courseId/lectures/:lectureId/lectureStudents" element={
                        <ProtectedRoute permissions={["read:course:lectures"]}>
                            <LectureStudents />
                        </ProtectedRoute>
                    } />
                {/* Lecture Quiz */}
                <Route
                    path="/courses/:courseId/lectures/:lectureId/items/:itemId" element={
                        <ProtectedRoute permissions={["read:course:lecture:quiz:quiestions"]} allRequired={true}>
                            <QuizesDB />
                        </ProtectedRoute>
                    } />

                <Route
                    path="/courses/:courseId/lectures/:lectureId/items/:itemId/questions/:questionId/options" element={
                        <ProtectedRoute permissions={["read:course:lecture:quiz:quiestion:options"]} allRequired={true}>
                            <QuizOptionsDB />
                        </ProtectedRoute>
                    } />

                <Route
                    path="/courses/:courseId/lectures/:lectureId/items/:itemId/questions/view" element={
                        <ProtectedRoute permissions={["read:course:lecture:quiz:quiestions", "read:course:lecture:quiz:quiestion:options"]} allRequired={true}>
                            <QuestionsAndAnswersDB />
                        </ProtectedRoute>
                    } />

                {/* Lecture Voucher */}
                <Route
                    path="/courses/:courseId/lectures/:lectureId/vouchers" element={
                        <ProtectedRoute permissions={["read:courses", "read:course:lectures", "create:course:lecture:vouchers"]} allRequired={true}>
                            <LectureVouchersDB />
                        </ProtectedRoute>
                    }
                />

                {/* offers */}
                <Route
                    path="/offers" element={
                        <ProtectedRoute permissions={["read:offers"]}>
                            <OffersDB />
                        </ProtectedRoute>
                    } />

                <Route
                    path="/offers/create" element={
                        <ProtectedRoute permissions={["create:offers"]}>
                            <CreateOffersDB />
                        </ProtectedRoute>
                    } />

                <Route
                    path="/offers/:id/edit" element={
                        <ProtectedRoute permissions={["update:offers"]}>
                            <UpdateOffersDB />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/offers/:offerId/vouchers" element={
                        <ProtectedRoute permissions={["create:offer:vouchers"]}>
                            <OfferVouchersDB />
                        </ProtectedRoute>
                    } />

                <Route
                    path="/permissions" element={
                        <ProtectedRoute
                            permissions={["read:permissions", "read:users:permissions", "associate:users:permissions", "associate:users:roles", "read:roles",]}
                            allRequired={true}
                        >
                            <AssociateUsersPermissionsDB />
                        </ProtectedRoute>
                    } />

                <Route
                    path="/roles" element={
                        <ProtectedRoute permissions={["read:roles"]}>
                            <RolesDB />
                        </ProtectedRoute>
                    } />

                <Route
                    path="/roles/create" element={
                        <ProtectedRoute permissions={["create:roles"]}>
                            <CreateRolesDB />
                        </ProtectedRoute>
                    } />

                <Route
                    path="/roles/:id/edit" element={
                        <ProtectedRoute permissions={["update:roles"]}>
                            <UpdateRolesDB />
                        </ProtectedRoute>
                    } />



                <Route path="*" element={<ErrorPage status={404} error={"هذه الصفحة غير موجودة"} />} />

            </Route>
        </Routes>
    )
}

export default DashBoardRoutes